import { Context } from '@front10/helpers/dist/Context';
import React, { useContext } from 'react';
import Box from './../../../elements/Box';
import Button from './../../../elements/Button';
import Text from './../../../elements/Text';
import VisuallyHidden from '@reach/visually-hidden';

export default function SuggestedDate(props) {
  const {
    suggestedFirstTextSettings = {},
    suggestedFirstTextLabelKey = 'cmp-date-control-suggested-try',
    suggestedButtonTextSettings = {},
    suggestedSecondTextSettings = {},
    suggestedSecondTextLabelKey = 'cmp-date-control-suggested-description',
    infoSuggestedSettings = {},
    suggestedData,
    showSuggested = false,
    disabled,
    suggestedDateFormat = 'D MMM YYYY',
    onClickSuggestedDate = () => {},
    isMobile = false,
    onKeyDown = (e) => {},
    endDate
  } = props;
  const { translate, moment: ingloriousMomentNeverUseMe } = useContext(Context);
  return (
    <>
      {!isMobile && showSuggested && !disabled && suggestedData !== null && (
        <Box {...infoSuggestedSettings}>
          <Text {...suggestedFirstTextSettings}>
            {translate(suggestedFirstTextLabelKey, 'Try')}
          </Text>
          <Button
            role="link"
            {...suggestedButtonTextSettings}
            onClick={() => onClickSuggestedDate(suggestedData.date)}
            onKeyDown={onKeyDown}
          >
            {ingloriousMomentNeverUseMe(suggestedData.date).format(suggestedDateFormat)}
          </Button>

          <Text {...suggestedSecondTextSettings}>
            {translate(
              suggestedSecondTextLabelKey,
              `for lowest fare of  ${suggestedData.currencyCode}  ${suggestedData.price}* in the next 30 days`
            )}
          </Text>
        </Box>
      )}
      <VisuallyHidden role="status">
        {showSuggested
          ? `${translate(suggestedFirstTextLabelKey, 'Try')} ${ingloriousMomentNeverUseMe(
              suggestedData.date
            ).format(suggestedDateFormat)} ${translate(
              suggestedSecondTextLabelKey,
              `for lowest fare of  ${suggestedData.currencyCode}  ${suggestedData.price}* in the next 30 days`
            )}`
          : ''}
        {!showSuggested && endDate !== undefined
          ? `${translate(
              'cmp-low-fare-calendar-selected-date-label',
              'Selected return date'
            )} ${ingloriousMomentNeverUseMe(endDate).format(suggestedDateFormat)}`
          : ''}
      </VisuallyHidden>
    </>
  );
}
